import React from 'react';
import { FormController, FormLabel, Dropdown, MenuItem } from '@one-thd/sui-atomic-components';
import { updateUrlParam } from '../../utils/general';
import { SORT_TYPES } from '../../utils/consts';
import { setSortEvent } from '../../utils/analytics';

interface IListDropDownProps {
  onSortChange: (sortBy: string) => void;
  disabled: boolean;
  sortBy: string;
  isB2B: boolean;
}

export const ListDropDown: React.FC<IListDropDownProps> = ({
  sortBy,
  onSortChange,
  disabled,
  isB2B
}) => {
  let sortByName = Object.keys(SORT_TYPES || {});
  if (!sortByName || !sortByName.length) {
    return null;
  }

  if (!isB2B) {
    sortByName = sortByName.filter((sortName) => sortName !== 'My Active Cards');
  }

  const handleSortChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event || !event.target) {
      return;
    }
    const _sortBy: string = event.target.value;
    updateUrlParam([{ key: 'sortBy', newValue: _sortBy.replaceAll(/ /g, '_') }]);
    onSortChange(_sortBy);
    setSortEvent(_sortBy);
  };

  return (
    <FormController fullWidth>
      <FormLabel htmlFor="sort-list-dropdown" id="sort-list-dropdown-label">
        Sort by
      </FormLabel>
      <Dropdown
        placeholder={sortByName[0]}
        id="sort-list-dropdown"
        value={sortBy}
        onChange={handleSortChange}
        data-testid="sort-list-dropdown"
        disabled={disabled}
      >
        {sortByName.map((sort, index) => (
          <MenuItem key={index} value={sort} data-testid="sort-list-item">
            {sort}
          </MenuItem>
        ))}
      </Dropdown>
    </FormController>
  );
};
